import React from "react";
import { useTranslation } from "react-i18next";
import { useParams, useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { ListingCard } from "@components/Pages";
import { NothingFilteredAlert, OrdersSummary, OrdersTable } from "@components/Statistics";
import { url_reverse } from "@components/Utils";

export default function StatisticsOrders({ developerId, header }) {
    const { t } = useTranslation();
    const params = useParams();
    const { apiData } = useAppApi(
        url_reverse("api:developer:statistics:orders", { developer_id: developerId, kind: params.kind })
    );
    const developerCommonInfo = useRouteLoaderData("developerCommonInfo");

    if (!apiData) return;

    const headerTools = apiData.object_list?.length > 0 && (
        <>
            <ExportButton
                size="sm"
                buildReport="sales"
                prms={{
                    "filter-stats_period": apiData.forms_data.filter.data.stats_period,
                    "filter-order_type": apiData.forms_data.filter.data.order_type,
                }}
            />{" "}
            <ExportButton
                size="sm"
                buildReport="games"
                prms={{
                    "filter-stats_period": apiData.forms_data.filter.data.stats_period,
                    "filter-order_type": apiData.forms_data.filter.data.order_type,
                }}
                buttonText={t("Отчет по играм")}
            />{" "}
            {developerCommonInfo.has_sellable_games && (
                <>
                    <ExportButton
                        size="sm"
                        buildReport="summary"
                        prms={{
                            "filter-stats_period": apiData.forms_data.filter.data.stats_period,
                            "filter-order_type": apiData.forms_data.filter.data.order_type,
                        }}
                        buttonText={t("Акт")}
                    />{" "}
                </>
            )}
            {[250, 279, 310, 348].includes(developerCommonInfo.developer.id) && (
                <ExportButton
                    size="sm"
                    buildReport="summary_io"
                    prms={{
                        "filter-stats_period": apiData.forms_data.filter.data.stats_period,
                    }}
                    buttonText={t("Акт об ИО")}
                />
            )}
        </>
    );

    return (
        <ListingCard header={header} headerTools={headerTools} filterComponent={false}>
            <RenderForm prefix="filter" submitButtonText={t("Построить")} submitMethod="get" />
            <OrdersSummary />
            <NothingFilteredAlert />
            <OrdersTable devId={developerCommonInfo.developer.id} />
        </ListingCard>
    );
}
